import type { BareMetalProvisioningMode } from './types';

/** 系统交付方式选项（展示文案 + 说明） */
export const PROVISIONING_MODE_OPTIONS: {
  value: BareMetalProvisioningMode;
  label: string;
  description: string;
}[] = [
  {
    value: 'Install',
    label: '安装新系统',
    description: '创建实例时重新安装操作系统',
  },
  {
    value: 'Adopt',
    label: '纳管已有系统',
    description: '保留物理机当前系统，不执行重新安装',
  },
];

/** 引导方式说明（选项后展示） */
export const BOOT_MODE_DESCRIPTIONS: Record<string, string> = {
  PXE: '网络引导安装',
  ISO: '虚拟介质引导安装',
};

export function getBootModeDescription(value: string): string | undefined {
  return BOOT_MODE_DESCRIPTIONS[value];
}
